import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { Subject, combineLatest } from 'rxjs'
import { KeySystemNavConfig } from '../../../configuration/key.system.nav.config'
import { MatTableDataSource } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { KeySystem, Structure, RegisterNumber } from '../../../models/dev.test.models'
import { ErrorService } from '../../../services/error.service'
import { takeUntil, take, filter } from 'rxjs/operators'
import { LoadingService } from '../../../services/loading.service'
import { KeyingStructureService } from '../../../services/keying.structure.service'
import { KeyingSystemService } from '../../../services/keying.system.service'

@Component({
    selector: 'app-registry-number',
    templateUrl: './registry-number.component.html',
    styleUrls: ['./registry-number.component.scss'],
    standalone: false
})
export class RegistryNumberComponent implements OnInit, OnDestroy, AfterViewInit {
  displayedColumns: string[] = ['keySymbol', 'registryNumber']
  dataSource
  destroy$ = new Subject()
  structure: Structure
  keySystem: KeySystem
  isSearching = false
  isLoading = false
  currentPage = 0
  pageSize = 25
  registryNumbers
  @ViewChild(MatPaginator) paginator: MatPaginator

  constructor(
    private keyingSystemService: KeyingSystemService,
    private keyingStructureService: KeyingStructureService,
    private loadingService: LoadingService,
    private errorService: ErrorService,
    private keySystemNavConfig: KeySystemNavConfig
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    // Load structure and key system data to populate navigation
    combineLatest([
      this.keyingStructureService.structure$.pipe(filter((x) => !!x)),
      this.keyingSystemService.keySystem$.pipe(filter((x) => !!x))
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        ([structure, keySystem]: [Structure, KeySystem]) => {
          this.structure = structure
          this.keySystem = keySystem
          // Set navigation with 'Registry Numbers' as active page - fixes nav disappearing on hard refresh
          this.keySystemNavConfig.setNav('Registry Numbers', this.structure, this.keySystem)
          this.getRegistryNumber()
        },
        (error) => {
          this.errorService.throw(error)
        }
      )
  }

  ngAfterViewInit() {}

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  getRegistryNumber() {
    this.loadingService.set({ isLoading: true, message: 'Registry Numbers' })
    this.keyingStructureService
      .getKeysystemRegistryNumbers(this.structure.id, this.keySystem.id)
      .pipe(take(1))
      .subscribe(
        (registryNumber) => {
          this.loadingService.set({ message: null, isLoading: false })
          this.registryNumbers = registryNumber
          this.dataSource = new MatTableDataSource<RegisterNumber>(registryNumber)
          setTimeout(() => {
            this.dataSource.paginator = this.paginator
          })
        },
        (error) => {
          this.loadingService.set({ message: null, isLoading: false })
          this.errorService.throw(error)
        }
      )
  }
}
